import {
  NavigationState,
  PartialState,
  useNavigationState,
} from "@react-navigation/native";

import { theme } from "@whoosh/design-system/src/theme/restyle/theme";

export const ROUTES_ALWAYS_HIDDEN = new Set([
  "Login",
  "Home",
  "MainHome",
  "EventDetail",
  "EventSignupSummary",
  "MoveBooking",
  "BookingSummary",
]);

/** Routes that never show Topbar (fixed or embedded); mobile header uses legacy nav only. */
export const ROUTES_WITHOUT_TOPBAR = new Set(["MoveBooking"]);

export const ROUTES_HIDDEN_BELOW_BREAKPOINT: Record<string, number> = {
  Agenda: theme.breakpoints.agendaSplit,
};

export const getDeepestRouteName = (
  state: NavigationState | PartialState<NavigationState>
): string | null => {
  const index = state.index;
  if (typeof index !== "number" || !state.routes) return null;
  const route = state.routes[index];
  if (!route?.name) return null;
  if (route.state) {
    const deeper = getDeepestRouteName(route.state);
    if (deeper !== null) return deeper;
  }
  return route.name;
};

export const useClubStackDeepestRouteName = (): string | null => {
  return useNavigationState((state) => {
    if (!state) return null;
    return getDeepestRouteName(state);
  });
};
